import React from 'react';
import styles from './warningDialog.module.scss';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import { IconInfo } from '@americanexpress/dls-icons';
import { DLSSize } from 'src/types/dls-size.enum';
import Selectors from 'src/utils/selectors';

export interface WarningDialogProps {
    text: string;
    className?: string;
}
export default function WarningDialog({ text, className }: WarningDialogProps): JSX.Element {
    return (
        <div className={`${styles.warningDialog} ${className}`} data-cy={Selectors.SpendSmart.WARNING_DIALOG}>
            <IconInfo size={DLSSize.MEDIUM} className={styles.icon} data-cy={Selectors.SpendSmart.INFO_ICON} />
            <Typography
                variant={TypographyVariants.BODY}
                component="p"
                className={styles.text}
                data-cy={Selectors.SpendSmart.WARNING_DIALOG_TEXT}
            >
                {text}
            </Typography>
        </div>
    );
}
